import { QueryClient } from '@tanstack/react-query';

import { CustomError } from './model/custom-fetch';
import fetcherQuery from './fetcher-query';

const MAX_RETRY_QUERY = 2;
const MAX_RETRY_MUTATION = 2;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: fetcherQuery,
      retry: (failureCount, err) => {
        const error = err as CustomError;
        return failureCount < MAX_RETRY_QUERY && error.retry;
      },
      enabled: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: (failureCount, err) => {
        const error = err as CustomError;
        return failureCount < MAX_RETRY_MUTATION && error.retry;
      },
    },
  },
});
